import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const urlParams = new URLSearchParams(window.location.search);
    const tab = urlParams.get('tab');
    
    if (tab === 'diagnostic' || tab === 'genetic_histories' || tab === 'afip' || tab === 'evolucion') {
      // Desactivar la tab de precios
      const pricingTab = document.getElementById('pricing-tab');
      const pricing = document.getElementById('pricing');
      if (pricingTab && pricing) {
        pricingTab.classList.remove('active');
        pricing.classList.remove('show', 'active');
      }
      
      if (tab === 'diagnostic') {
        // Activar la tab de diagnóstico
        const diagnosticTab = document.getElementById('diagnostic-tab');
        const diagnostic = document.getElementById('diagnostic');
        if (diagnosticTab && diagnostic) {
          diagnosticTab.classList.add('active');
          diagnostic.classList.add('show', 'active');
        }
      } else if (tab === 'genetic_histories') {
        // Activar la tab de antecedentes genéticos
        const geneticTab = document.getElementById('genetic-tab');
        const genetic = document.getElementById('genetic');
        if (geneticTab && genetic) {
          geneticTab.classList.add('active');
          genetic.classList.add('show', 'active');
        }
      } else if (tab === 'afip') {
        // Activar la tab de AFIP
        const afipTab = document.getElementById('afip-tab');
        const afip = document.getElementById('afip');
        if (afipTab && afip) {
          afipTab.classList.add('active');
          afip.classList.add('show', 'active');
        }
      } else if (tab === 'evolucion') {
        // Activar la tab de evolución del valor de la consulta
        const evolucionTab = document.getElementById('evolucion-tab');
        const evolucion = document.getElementById('evolucion');
        if (evolucionTab && evolucion) {
          evolucionTab.classList.add('active');
          evolucion.classList.add('show', 'active');
        }
      }
    }
  }
} 